"use client";

import { useTranslations } from "use-intl";

import { ActiveNotificationIcon, ArrowForwardIcon } from "@/components/appIcons";
import { TelegramIcon } from "@/components/icons/telegram-icon";
import { WhatsAppIcon } from "@/components/icons/whatsapp-icon";
import { Link } from "@/components/link";

export function AlertsCallout(_props: { surface: string }) {
  const t = useTranslations("alerts");

  return (
    <section className="mx-auto my-10 w-full max-w-[1200px] px-4 md:px-10">
      <div className="relative overflow-hidden rounded-2xl border border-primary/25 bg-gradient-to-br from-primary/10 via-card to-card p-6 shadow-sm sm:p-8">
        <div className="relative flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex max-w-2xl flex-col gap-4 sm:flex-row sm:items-start">
            <span className="flex -space-x-2 self-start" aria-hidden="true">
              <span className="flex size-11 items-center justify-center rounded-full bg-primary text-primary-foreground ring-2 ring-card">
                <ActiveNotificationIcon className="text-xl" decorative />
              </span>
              <span className="flex size-11 items-center justify-center rounded-full bg-[#229ED9] text-white ring-2 ring-card">
                <TelegramIcon className="size-6" />
              </span>
              <span className="flex size-11 items-center justify-center rounded-full bg-[#25D366] text-[#07170d] ring-2 ring-card">
                <WhatsAppIcon className="size-6" />
              </span>
            </span>
            <div>
              <h2 className="text-xl font-black tracking-tight">{t("calloutTitle")}</h2>
              <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">
                {t("calloutDescription")}
              </p>
            </div>
          </div>
          <Link
            to="/alerts"
            className="inline-flex min-h-12 shrink-0 items-center justify-center gap-2 rounded-xl bg-primary px-5 text-sm font-black text-primary-foreground transition hover:bg-primary/90"
          >
            {t("calloutOptionsCta")}
            <ArrowForwardIcon decorative />
          </Link>
        </div>
      </div>
    </section>
  );
}
